"use strict";

exports.__esModule = true;
exports.TextEditor = exports.EDITOR_TYPE = void 0;
var _textEditor = require("./textEditor");
exports.EDITOR_TYPE = _textEditor.EDITOR_TYPE;
exports.TextEditor = _textEditor.TextEditor;


//////////////////
// WEBPACK FOOTER
// ./~/handsontable/editors/textEditor/index.js
// module id = 155
// module chunks = 0